import request from "@/axios/index";
// 插入单号
export function insertOddNum(data) {
  return request({
    url: "/noConfig",
    method: "post",
    data
  })
}
// 查询单号
export function selectOddNum(params) {
  return request({
    url: "/noConfig/selectByItemConfigId",
    method: "get",
    params
  })
}
// 更新单号
export function upDataOddNum(data) {
  return request({
    url: "/noConfig",
    method: "put",
    data
  })
}

export function deleteOddNum(id) {
  return request({
    url: `/noConfig/${id}`,
    method: "delete"
  })
}